







































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {Component, Prop, PropSync} from "vue-property-decorator";
import {FormModel} from "ant-design-vue";
import {ShiftStore} from "@/modules/shift/store";
import {assignValueToForm} from "@/shared/services/helper/utils";
import {ShiftType} from "@/modules/shift/type/shifttype";

const form = {
    id: undefined,
    start: undefined,
    end: undefined,
    type: ShiftType.Limit
}

const rules = {
    start: [{ required: true, message: "Nhập thời gian bắt đầu", trigger: "change" }],
    end: [{ required: true, message: "Nhập thời gian bắt đầu", trigger: "change" }],
}
@Component({
    name: "ShiftForm"
})
export default class extends mixins(CommonMixin) {
    @PropSync("visibleForm", { required: true, type: Boolean}) syncVisibleForm!: boolean;
    @Prop() readonly shiftId!: any;
    form = { ...form };
    rules = { ...rules } as any;
    ShiftType = ShiftType;

    created() {
        if (this.shiftId) {
            this.form = assignValueToForm(this.form, ShiftStore.data[this.shiftId]);
        }
    }

    onchangeLimit(val) {
        if (val) {
            this.rules = { ...rules };
        } else {
            this.rules = { ...{} };
        }
    }

    onSubmit() {
        (this.$refs.shiftForm as FormModel).validate(async (valid) => {
            if (!valid) return;
            try {
                this.shiftId
                    ? await ShiftStore.editShift(this.form)
                    : await ShiftStore.createShift(this.form);
                this.resetForm();
                this.syncVisibleForm = false;
                this.$message.success(`${this.shiftId ? 'Sửa' : 'Tạo'} thành công`);
            } catch (e) {
                this.$message.error(e?.response?.data?.message || `${this.shiftId ? 'Sửa' : 'Tạo'} ca thất bại`);
            }
        })
    }

    resetForm() {
        this.form = { ...form };
    }
}
